import { render, staticRenderFns } from "./DownloadDocsScreen.vue?vue&type=template&id=7f592ba9&"
import script from "./DownloadDocsScreen.vue?vue&type=script&lang=js&"
export * from "./DownloadDocsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports